// extracted by css-extract-rspack-plugin
export default {"cls1":"DownloadOptionCard-cls1_zOq","cls2":"DownloadOptionCard-cls2_LVC DownloadOptionCard-cls1_zOq"};